'use strict'

module.exports = class SponsoredDealsWidgetModel extends Backbone.Model
  url: '/browse/search/sponsored-deals-widget'